import { Vue } from 'types-vue';
import { MatchMedia } from 'vue-component-media-queries'

Vue.component('MatchMedia', MatchMedia)